import { UserInfo } from '@core/types/user.interface';
import { MixpanelUser } from '@core/types/user.interface';

export function toMixpanelUser(userInfo: UserInfo): MixpanelUser {
  return {
    userId: userInfo.id,
    userName: userInfo.userName.trim(),
    userEmail: userInfo.email,
    companyId: userInfo.company.id,
    companyNumber: userInfo.company.number
  };
}
